import { render } from "./CountryQuiz.vue?vue&type=template&id=5ea2b1b3&scoped=true"
import script from "./CountryQuiz.vue?vue&type=script&lang=js"
export * from "./CountryQuiz.vue?vue&type=script&lang=js"

import "./CountryQuiz.vue?vue&type=style&index=0&id=5ea2b1b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea2b1b3"]])

export default __exports__